import React, { useEffect, useState } from 'react';

import { hesabimGetir, paraYatirmalariGetir, paraYatir, paraCekmeleriGetir, paraCek, toplamMasrafGetir, bakiyeAkisiAc } from '../services/hesabimApi';
import { fiyatFormatla } from '../utils/fiyat';

function Hesabim() {
  const [email, setEmail] = useState('');
  const [bakiye, setBakiye] = useState(0);
  const [bakiyeYukleniyor, setBakiyeYukleniyor] = useState(true);
  const [bakiyeHatasi, setBakiyeHatasi] = useState('');

  const [yatirmalar, setYatirmalar] = useState([]);
  const [listeYukleniyor, setListeYukleniyor] = useState(true);
  const [listeHatasi, setListeHatasi] = useState('');

  const [tutar, setTutar] = useState('');
  const [formHatasi, setFormHatasi] = useState('');
  const [gonderiliyor, setGonderiliyor] = useState(false);

  const [cekmeler, setCekmeler] = useState([]);
  const [cekmeListeYukleniyor, setCekmeListeYukleniyor] = useState(true);
  const [cekmeListeHatasi, setCekmeListeHatasi] = useState('');

  const [cekmeTutar, setCekmeTutar] = useState('');
  const [cekmeFormHatasi, setCekmeFormHatasi] = useState('');
  const [cekmeGonderiliyor, setCekmeGonderiliyor] = useState(false);

  const [toplamMasraf, setToplamMasraf] = useState(null);

  useEffect(() => {
    let iptalEdildi = false;

    hesabimGetir()
      .then(veri => {
        if (iptalEdildi) return;
        setEmail(veri.email);
        setBakiye(veri.bakiye);
        setBakiyeYukleniyor(false);
      })
      .catch(err => {
        if (iptalEdildi) return;
        setBakiyeHatasi(err.message);
        setBakiyeYukleniyor(false);
      });

    paraYatirmalariGetir()
      .then(veri => {
        if (iptalEdildi) return;
        setYatirmalar(veri);
        setListeYukleniyor(false);
      })
      .catch(err => {
        if (iptalEdildi) return;
        setListeHatasi(err.message);
        setListeYukleniyor(false);
      });

    paraCekmeleriGetir()
      .then(veri => {
        if (iptalEdildi) return;
        setCekmeler(veri);
        setCekmeListeYukleniyor(false);
      })
      .catch(err => {
        if (iptalEdildi) return;
        setCekmeListeHatasi(err.message);
        setCekmeListeYukleniyor(false);
      });

    toplamMasrafGetir()
      .then(veri => {
        if (iptalEdildi) return;
        setToplamMasraf(veri);
      })
      .catch(() => {});

    return () => { iptalEdildi = true; };
  }, []);

  // Başka bir sekmede yapılan para yatırma/alım/satım işlemleri de anında
  // yansısın diye bakiye SSE akışına ayrıca abone olunuyor.
  useEffect(() => {
    return bakiyeAkisiAc(yeniBakiye => setBakiye(yeniBakiye));
  }, []);

  function handleSubmit(event) {
    event.preventDefault();
    setFormHatasi('');
    setGonderiliyor(true);

    paraYatir(Number(tutar))
      .then(sonuc => {
        setBakiye(sonuc.bakiye);
        setYatirmalar(onceki => [{ id: sonuc.id, tutar: sonuc.tutar, created_at: new Date().toISOString() }, ...onceki]);
        setTutar('');
      })
      .catch(err => setFormHatasi(err.message))
      .finally(() => setGonderiliyor(false));
  }

  function handleCekmeSubmit(event) {
    event.preventDefault();
    setCekmeFormHatasi('');
    setCekmeGonderiliyor(true);

    paraCek(Number(cekmeTutar))
      .then(sonuc => {
        setBakiye(sonuc.bakiye);
        setCekmeler(onceki => [{ id: sonuc.id, tutar: sonuc.tutar, created_at: new Date().toISOString() }, ...onceki]);
        setCekmeTutar('');
      })
      .catch(err => setCekmeFormHatasi(err.message))
      .finally(() => setCekmeGonderiliyor(false));
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
        <h1 className="text-lg font-bold text-slate-800 mb-1">Hesabım</h1>
        <p className="text-sm text-slate-500 mb-4">{email}</p>

        {bakiyeHatasi && <p className="text-sm text-red-600 mb-3">{bakiyeHatasi}</p>}

        <div className="rounded-xl bg-slate-900 px-6 py-5">
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">Bakiye</p>
          <p className="mt-1 text-3xl font-black text-white">
            {bakiyeYukleniyor ? '—' : fiyatFormatla(bakiye) + ' ₺'}
          </p>


        </div>

        {toplamMasraf !== null && (
           <p className="bg-slate-200 rounded-xl text-sm text-slate-600 px-6 py-5 my-3">
            Toplam masraf: {fiyatFormatla(toplamMasraf)} ₺
           </p>
          )}


        
      </div>

      <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
        <h2 className="text-lg font-bold text-slate-800 mb-1">Para Yatır</h2>
        <p className="text-sm text-slate-500 mb-4">Yatırdığınız tutar anında bakiyenize eklenir.</p>

        <form onSubmit={handleSubmit} className="flex gap-3">
          <input
            type="number" required min="0.01" step="0.01" placeholder="Tutar (₺)"
            value={tutar} onChange={e => setTutar(e.target.value)}
            className="flex-1 px-3 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-400/40 focus:border-sky-400 transition-all"
          />
          <button
            type="submit" disabled={gonderiliyor}
            className="px-4 py-2 bg-sky-600 hover:bg-sky-700 disabled:opacity-60 disabled:cursor-not-allowed text-white text-sm font-semibold rounded-lg shadow-sm transition-colors"
          >
            {gonderiliyor ? 'Yatırılıyor...' : 'Para Yatır'}
          </button>
        </form>

        {formHatasi && <p className="text-sm text-red-600 mt-3">{formHatasi}</p>}
      </div>

      <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
        <div className="text-lg font-bold text-slate-800 mb-4">Para Yatırma Geçmişi</div>

        {listeHatasi && <p className="text-sm text-red-600 mb-3">{listeHatasi}</p>}
        {listeYukleniyor && <p className="text-sm text-slate-500">Yükleniyor...</p>}

        {!listeYukleniyor && yatirmalar.length === 0 && (
          <p className="text-sm text-slate-500">Henüz para yatırma işlemi yok.</p>
        )}

        {!listeYukleniyor && yatirmalar.length > 0 && (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-xs font-semibold uppercase tracking-wide text-slate-500 border-b border-slate-200">
                  <th className="py-2 pr-3">Tarih</th>
                  <th className="py-2 pr-3">Tutar</th>
                </tr>
              </thead>
              <tbody>
                {yatirmalar.map(y => (
                  <tr key={y.id} className="border-b border-slate-100">
                    <td className="py-2 pr-3 text-slate-500 text-xs">{new Date(y.created_at).toLocaleString('tr-TR')}</td>
                    <td className="py-2 pr-3 font-semibold text-emerald-700">+{fiyatFormatla(Number(y.tutar))} ₺</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
        <h2 className="text-lg font-bold text-slate-800 mb-1">Para Çek</h2>
        <p className="text-sm text-slate-500 mb-4">Çektiğiniz tutar anında bakiyenizden düşülür.</p>

        <form onSubmit={handleCekmeSubmit} className="flex gap-3">
          <input
            type="number" required min="0.01" step="0.01" placeholder="Tutar (₺)"
            value={cekmeTutar} onChange={e => setCekmeTutar(e.target.value)}
            className="flex-1 px-3 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-400/40 focus:border-sky-400 transition-all"
          />
          <button
            type="submit" disabled={cekmeGonderiliyor}
            className="px-4 py-2 bg-red-600 hover:bg-red-700 disabled:opacity-60 disabled:cursor-not-allowed text-white text-sm font-semibold rounded-lg shadow-sm transition-colors"
          >
            {cekmeGonderiliyor ? 'Çekiliyor...' : 'Para Çek'}
          </button>
        </form>

        {cekmeFormHatasi && <p className="text-sm text-red-600 mt-3">{cekmeFormHatasi}</p>}
      </div>

      <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
        <div className="text-lg font-bold text-slate-800 mb-4">Para Çekme Geçmişi</div>

        {cekmeListeHatasi && <p className="text-sm text-red-600 mb-3">{cekmeListeHatasi}</p>}
        {cekmeListeYukleniyor && <p className="text-sm text-slate-500">Yükleniyor...</p>}

        {!cekmeListeYukleniyor && cekmeler.length === 0 && (
          <p className="text-sm text-slate-500">Henüz para çekme işlemi yok.</p>
        )}

        {!cekmeListeYukleniyor && cekmeler.length > 0 && (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-xs font-semibold uppercase tracking-wide text-slate-500 border-b border-slate-200">
                  <th className="py-2 pr-3">Tarih</th>
                  <th className="py-2 pr-3">Tutar</th>
                </tr>
              </thead>
              <tbody>
                {cekmeler.map(c => (
                  <tr key={c.id} className="border-b border-slate-100">
                    <td className="py-2 pr-3 text-slate-500 text-xs">{new Date(c.created_at).toLocaleString('tr-TR')}</td>
                    <td className="py-2 pr-3 font-semibold text-red-600">-{fiyatFormatla(Number(c.tutar))} ₺</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

    </div>
  );
}

export default Hesabim
